
export default () => ({
    checkoutInfo: JSON.parse(sessionStorage.getItem('checkout-info')) || null,
    appointmentToUpdate: JSON.parse(sessionStorage.getItem('appoinment-to-update')) || null
})